import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "../../layout";
import { JobExecutionsList } from "./list";
import { BasePathContext } from "../../reactContexts/basePathContext";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import "./jobExecutions.css";

const JobExecutionsRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);
  const basePath = `/console/org/${org}/job-executions`;

  return (
    <Layout>
      <BasePathContext.Provider value={basePath}>
        <div className="job-executions-page px-8 py-6">
          <Routes>
            <Route index element={<JobExecutionsList />} />
          </Routes>
        </div>
      </BasePathContext.Provider>
    </Layout>
  );
};

export default JobExecutionsRoute;
